export const enum TrackingEventName {
  Click = 'global-header_click',
}

export const enum TrackingPlacement {
  UspBar = 'usp-bar',
  UrgentMessageBar = 'urgent-message-bar',
}
